import React from 'react';

import { Card, FormItem } from '../../../components';
import { Input } from '../../../components/Input';
import { SilenceTriggersList } from '../../../components/SilenceTriggersList';
import type { AgentForm as AgentFormType } from '../../../utilities';
import { MIN_TIMEOUT_SEC } from '../const';
import { validateSilenceTriggers } from '../utils/validateSilenceTriggers';
import { validateMinValue } from '../utils/validators';

export type SilenceTriggersSettingsProps = {
  disabled?: boolean;
};

export const SilenceTriggersSettings: React.FC<
  SilenceTriggersSettingsProps
> = ({ disabled }) => {
  return (
    <Card
      collapsable
      size="unset"
      title="Silence Triggers"
      name="agentpage.silenceTriggers"
      contentClassName="flex flex-col gap-y-md"
      subtitle="Configure actions to take when the user is inactive for a specified duration"
    >
      <FormItem<AgentFormType>
        name="automute_timeout_sec"
        label="Automute timeout (seconds) DEPRECATED"
        validate={validateMinValue(MIN_TIMEOUT_SEC)}
      >
        <Input numeric roundTo={4} disabled={disabled} />
      </FormItem>
      <FormItem<AgentFormType>
        name="autoend_after_mute_timeout_sec"
        label="Autoend after mute timeout (seconds) DEPRECATED"
        validate={validateMinValue(MIN_TIMEOUT_SEC)}
      >
        <Input numeric roundTo={4} disabled={disabled} />
      </FormItem>
      <FormItem<AgentFormType>
        name="silence_triggers"
        label="Triggers"
        validate={validateSilenceTriggers}
        renderError={() => null}
      >
        <SilenceTriggersList disabled={disabled} />
      </FormItem>
    </Card>
  );
};
